import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import PlacePickerModal from './PlacePickerModal'
import SelectableLink from '../../../components/actions/SelectableLink'

const PlacePicker = ({ type, value, label, icon, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <SelectableLink
        icon={icon || 'RiMapPinLine'}
        label={label || 'Locais'}
        value={compactString(value, { t: t, tField: 'placeIds' })}
        onClick={() => setOpen(true)}
        type={type}
      />
      <PlacePickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default PlacePicker
